module.exports = __webpack_public_path__ + "static/media/Analysis.f35417fd.svg";